import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './wrike-folder-board-list.types';
import * as constants from './wrike-folder-board-list.constants';

export const wrikeFolderBoardListReducer = generateResourceReducer<types.IWrikeFolderBoardList>({
  STORE: constants.STORE_WRIKE_FOLDER_BOARD_LIST,
  CLEAR: constants.CLEAR_WRIKE_FOLDER_BOARD_LIST,
});
